import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { FolderGridItemObject } from '@libs/types/src/services/object-type/folder/folder.object';
import { ServiceGridItemObject } from '@libs/types/src/services/object-type/service.object';
import { EPrescriptionObject } from '@libs/types/src/services/object-type/sukl/e-prescription.object';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import {
    FolderMedicationUpsertDialogComponent,
} from '../folder-medications/folder-medication-upsert-dialog/folder-medication-upsert-dialog.component';

@Injectable({ providedIn: 'root' })
export class FolderEPrescriptionMedicationService {
    private readonly dialogService = inject(BaseDialogService);

    public async upsertMedications(
        prescription: EPrescriptionObject,
        folder: FolderGridItemObject | null,
        service: ServiceGridItemObject | undefined,
    ): Promise<void> {
        for (const prescriptionMedication of prescription.medications ?? []) {
            const ref = this.dialogService.open(FolderMedicationUpsertDialogComponent, {
                styleClass: 'p-dialog-width-50',
                data: {
                    folderId: folder?.id,
                    personId: folder?.personId,
                    service,
                    prescription,
                    prescriptionMedication,
                },
            });
            // Wait for removal so the dialog service allows opening the same component again.
            await firstValueFrom(ref.onDestroy);
        }
    }
}
